<template>
  <div
    ref="toast"
    class="toast fade w-100"
    :class="{
      [`bg_${variant}`]: !!variant,
      hide: !isShow,
      show: isShow
    }"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <div
      v-if="!!title"
      class="toast-header"
    >
      <span
        class="mr-auto toast_title"
        :class="{
          'text-white': variant !== 'default'
        }"
      >{{ title }}</span>
      <button
        type="button"
        class="ml-2 mb-1 close text-muted"
        data-dismiss="toast"
        aria-label="Close"
        @click="closeToast"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div
      class="toast-body d-flex"
    >
      <div
        class="mr-auto"
        v-html="message"
      />
      <button
        v-if="!title"
        type="button"
        class="ml-2 mb-1 close text-white"
        data-dismiss="toast"
        aria-label="Close"
        @click="closeToast"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</template>
<script>
import '~style/components/toast.scss'
export default {
  name: 'BootstrapToast',
  props: {
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      required: true
    },
    variant: {
      type: String,
      default: 'default'
    },
    delay: {
      type: Number,
      default: 3000
    }
  },
  data () {
    return {
      isShow: true
    }
  },
  mounted () {
    if (this.delay > 0) {
      setTimeout(() => {
        this.isShow = false
      }, this.delay)
    }
  },
  methods: {
    closeToast () {
      this.isShow = false
    }
  }
}
</script>
